import { Loader } from "../../../../../../UI/Loaders/Loaders";
import useGetUserUnlockApprovalHistory from "../../../../hooks/useGetUserUnlockApprovalHistory";

export default function UnlockApprovalHistoryTab({ targetId }) {
  const { data, isLoading } = useGetUserUnlockApprovalHistory(targetId);

  if (isLoading) {
    return <Loader centered text="Loading unlock approval history..." />;
  }

  if (!data?.data?.length) {
    return (
      <p className="text-center text-muted p-y-3">
        No unlock approval history found for this user.
      </p>
    );
  }

  return (
    <div className="table-responsive">
      <table className="table">
        <thead className="bg-lighter-grey">
          <tr>
            <th>S/N</th>
            <th>Initiated By</th>
            <th>Approved By</th>
            <th>Status</th>
            <th>Additional Unlock Description</th>
            <th>Lock Reason</th>
            <th>Unlock Reason</th>
            <th>Comment</th>
            <th>Date Initiated</th>
          </tr>
        </thead>
        <tbody>
          {data.data.map((entry, index) => (
            <tr key={entry.transactionReference}>
              <td>{index + 1}</td>
              <td>{entry.initiatedByUserName || "—"}</td>
              <td>{entry.approvedByUserName || "—"}</td>
              <td>{entry.statusText || "—"}</td>
              <td>{entry.additionalUnlockDescription || "-"}</td>
              <td>{entry.lockReason || "—"}</td>
              <td>{entry.unlockReason || "—"}</td>
              <td>{entry.approvalComment || "—"}</td>
              <td>
                {entry.dateInitiated
                  ? entry.dateInitiated.substring(0, 10)
                  : "—"}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
